module.exports = __webpack_public_path__ + "img/android-chrome-192x192.015ae98c.png";